import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { FindAllCompaniesResponse } from '@ansvar-sakerhet/api-client';
import { toast } from '../../../../../../components/Toast';
import { useControl } from '../../../../components/ControlLayout';
import { usePatchCompany } from '../../../../../../traits/api/controls/usePatchCompany';
import {
  EditCompanyFormValues,
  useEditCompanyForm,
} from '../../hooks/useEditCompanyForm';
import { Input } from '../Input';
import { S } from './EditCompanyModal.styles';

type Props = {
  company: FindAllCompaniesResponse;
  onCancel: () => void;
};

export const EditCompanyModal: React.FC<Props> = (props) => {
  const { data: control } = useControl();
  const patchCompany = usePatchCompany(control.inspectionId);

  const { handleSubmit, register } = useEditCompanyForm({
    name: props.company.name,
    registrationNumber: props.company.registrationNumber,
  });

  const onErrors = () => {
    toast.error('Formuläret är inte korrekt ifyllt');
  };

  const handleSave = async (data: EditCompanyFormValues) => {
    try {
      await patchCompany.mutateAsync({
        companyId: props.company.companyId,
        name: data.name,
        registrationNumber: data.registrationNumber,
      });
      toast.success('Ändringarna har sparats');
      props.onCancel();
    } catch (e) {
      toast.error('Något gick fel, gick inte att spara ändringarna');
    }
  };

  return (
    <Dialog.Portal>
      <S.Overlay>
        <S.Content>
          <S.ContentHeader>
            <Dialog.Title asChild>
              <S.H4>Redigera {props.company.name}</S.H4>
            </Dialog.Title>

            <S.CloseButton asChild onClick={props.onCancel}>
              <S.Icon src="Close" width={20} height={20} />
            </S.CloseButton>
          </S.ContentHeader>

          <form onSubmit={handleSubmit(handleSave, onErrors)}>
            <S.FieldSet>
              <S.H5>Bolagsuppgifter</S.H5>

              <Input label="Namn" {...register('name')} />

              <Input label="Org nr" {...register('registrationNumber')} />
            </S.FieldSet>

            <S.ContentFooter>
              <Dialog.Close asChild onClick={props.onCancel}>
                <S.Button $outlined>Avbryt</S.Button>
              </Dialog.Close>

              <S.Button type="submit" disabled={patchCompany.isLoading}>
                Spara
              </S.Button>
            </S.ContentFooter>
          </form>
        </S.Content>
      </S.Overlay>
    </Dialog.Portal>
  );
};
